"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionSelectorModalHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const TranslationProvider_1 = require("../TranslationProvider/TranslationProvider");
const Constants_1 = require("../../../utils/Constants");
const styled_components_1 = __importDefault(require("styled-components"));
const StyledText = styled_components_1.default.text `
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 17px;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
`;
const RegionSelectorModalHeader = () => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const headerTextLabel = translate(Constants_1.chooseRegionTranslational);
    return (0, jsx_runtime_1.jsx)(StyledText, { children: headerTextLabel });
};
exports.RegionSelectorModalHeader = RegionSelectorModalHeader;
//# sourceMappingURL=RegionSelectorModalHeader.js.map